export default __webpack_public_path__ + "static/main-secondary02-45cab4d0c95e0c4628b0f76848e06ab5.jpg";